// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"85977286","453":"5bc82315"}[chunkId] + ".chunk.js";
};